// We need to import the CSS so that webpack will load it.
// The MiniCssExtractPlugin is used to separate it out into
// its own CSS file.
// import "../css/app.css"

// webpack automatically bundles all modules in your
// entry points. Those entry points can be configured
// in "webpack.config.js".
//
// Import deps with the dep name or local files with a relative path, for example:
//
//     import {Socket} from "phoenix"
//     import socket from "./socket"
//

import "mdn-polyfills/Object.assign";
import "mdn-polyfills/CustomEvent";
import "mdn-polyfills/String.prototype.startsWith";
import "mdn-polyfills/Array.from";
import "mdn-polyfills/Array.prototype.find";
import "mdn-polyfills/Array.prototype.some";
import "mdn-polyfills/NodeList.prototype.forEach";
import "mdn-polyfills/Element.prototype.closest";
import "mdn-polyfills/Element.prototype.matches";
import "mdn-polyfills/Node.prototype.remove";
import "child-replace-with-polyfill";
import "url-search-params-polyfill";
import "formdata-polyfill";
import "classlist-polyfill";
import "new-event-polyfill";
import "@webcomponents/template";
import "shim-keyboard-event-key";
import "core-js/features/set";
import "core-js/features/url";
import "phoenix_html";
import { TurnstileHook } from "phoenix_turnstile";
import { CountUp } from "countup.js";
import { Odometer } from "odometer_countup";
import { Counter } from "./counter.js";
import { Socket } from "phoenix";
import NProgress from "nprogress";
import { LiveSocket } from "phoenix_live_view";
import "./nav.js";
import { setupShareButtons } from "./share.js";
import { setupAdminCommandPalette } from "./admin-command-palette.js";
import { refreshParallax } from "./parallax.js";
import "./slides.js";
import "./page-images.js";
import "./page-trail.js";
import MultipleOptionsInput from "./multiple-option-input.js";
import Signature from "./sig.js";
import { setupChartHook } from "./chart-hook.js";
import { setupLineChartHook } from "./line-chart-hook.js";
import { setupCampaignChartHook } from "./campaign-chart-hook.js";
import { setupEmailChartHook } from "./email-chart-hook.js";
import Sortable from "sortablejs";
import Trix from "trix";
import Editor from "./rich-text-editor.js";
import { ReviewTour, VetTour, WelcomeTour } from "./tours.js";
import {
  AdminCampaignBuilderTourHook,
  setupAdminCampaignBuilderTour,
} from "./admin-campaign-builder-tour.js";
import JSConfetti from "js-confetti";
import print from "print-js";
import Flickity from "flickity";
import Vivus from "vivus";
import Square from "./square.js";
import AOS from "aos";

// Initialize AOS

// import { document } from "postcss"
// import InfiniteScroll from "../../_build/dev/lib/phonyx_live_chatboard/priv/static/assets/app.js"
// import InfiniteScroll from "../../_build/prod/lib/phonyx_live_chatboard/priv/static/assets/app.js"

// Add trix headings

window.multipleOptionsInput = MultipleOptionsInput;
window.IndustrySquare = Square;
setupShareButtons();
MultipleOptionsInput.initMultiselects();
document.addEventListener("DOMContentLoaded", setupAdminCampaignBuilderTour);
window.addEventListener("pageshow", setupAdminCampaignBuilderTour);

function clearEmbeddedFormErrors(form) {
  form.querySelectorAll("[data-embedded-form-field-error]").forEach((error) =>
    error.remove(),
  );

  let summary = form.querySelector("[data-embedded-form-errors]");
  if (summary) summary.replaceChildren();
}

function showEmbeddedFormSuccess(form, payload) {
  form.hidden = true;
  let message = document.createElement("p");
  message.setAttribute("role", "status");
  message.dataset.embeddedFormSuccess = "";
  message.textContent = payload.message || "Thanks — your response has been recorded.";
  form.insertAdjacentElement("afterend", message);
}

function showEmbeddedFormErrors(form, payload) {
  let summary = form.querySelector("[data-embedded-form-errors]");
  if (summary) summary.textContent = payload.error || "Please check your answers.";

  (payload.errors?.answers || []).forEach((answerErrors, index) => {
    let messages = answerErrors.answer || [];
    let field = form.querySelector(
      `[name="entry[answers][${index}][answer]"]`,
    );

    if (!field || messages.length === 0) return;

    let error = document.createElement("p");
    error.dataset.embeddedFormFieldError = "";
    error.setAttribute("role", "alert");
    error.textContent = messages.join(" ");
    field.setAttribute("aria-invalid", "true");
    field.insertAdjacentElement("afterend", error);
  });

  let invalid = form.querySelector('[aria-invalid="true"]');
  if (invalid) showFormStep(form, invalid.closest("[data-step]"));
}

// Compose V2 form_page: one step at a time, answers listed back on the last.
// Without this, every step shows in order and the form submits as normal.
function formSteps(form) {
  return [...form.querySelectorAll("[data-step]")];
}

function showFormStep(form, step) {
  let root = form.closest("[data-form-steps]");
  if (!root || !step) return;

  let steps = formSteps(form);
  let index = steps.indexOf(step);
  let last = index === steps.length - 1;

  steps.forEach((s, i) => (s.hidden = i !== index));
  root.querySelectorAll(".pg-steps-form__rail li").forEach((li, i) => {
    if (i === index) li.setAttribute("aria-current", "step");
    else li.removeAttribute("aria-current");
  });
  form.querySelector("[data-step-back]").hidden = index === 0;
  form.querySelector("[data-step-next]").hidden = last;
  form.querySelector("[data-step-submit]").hidden = !last;
  if (step.matches("[data-step-review]")) buildFormReview(form, steps);
  step.querySelector("legend")?.focus?.();
}

function currentFormStep(form) {
  return formSteps(form).find((s) => !s.hidden);
}

function firstInvalid(step) {
  return [...step.querySelectorAll("input, select, textarea")].find(
    (el) => el.type !== "hidden" && !el.checkValidity(),
  );
}

function buildFormReview(form, steps) {
  let list = form.querySelector("[data-step-review-list]");
  list.replaceChildren();

  steps.slice(0, -1).forEach((step) => {
    step.querySelectorAll(".pg-field, .pg-fieldset .pg-choices").forEach((field) => {
      let group = field.matches(".pg-choices") ? field.closest(".pg-fieldset") : null;
      let label = group
        ? group.querySelector("legend")?.textContent
        : field.querySelector("label")?.textContent;
      let values = [...field.querySelectorAll("input, select, textarea")]
        .filter((el) => el.type !== "hidden")
        .filter((el) => (el.type === "checkbox" ? el.checked : el.value !== ""))
        .map((el) => (el.type === "checkbox" && !group ? "Yes" : el.selectedOptions?.[0]?.textContent ?? el.value));

      let dt = document.createElement("dt");
      let dd = document.createElement("dd");
      dt.textContent = (label || "").trim();
      dd.textContent = values.length ? values.join(", ") : "Not answered";
      list.append(dt, dd);
    });
  });
}

function setupFormSteps() {
  document.querySelectorAll("[data-form-steps] form").forEach((form) => {
    if (form.dataset.stepsReady) return;
    form.dataset.stepsReady = "true";
    form.noValidate = true;
    form.querySelectorAll("[data-step] legend").forEach((l) => (l.tabIndex = -1));

    form.querySelector("[data-step-next]").addEventListener("click", () => {
      let steps = formSteps(form);
      let step = currentFormStep(form);
      let invalid = firstInvalid(step);
      if (invalid) return invalid.reportValidity();
      showFormStep(form, steps[steps.indexOf(step) + 1]);
    });

    form.querySelector("[data-step-back]").addEventListener("click", () => {
      let steps = formSteps(form);
      showFormStep(form, steps[steps.indexOf(currentFormStep(form)) - 1]);
    });

    showFormStep(form, formSteps(form)[0]);
  });
}

document.addEventListener("DOMContentLoaded", setupFormSteps);

// Capture phase, so an invalid hidden step stops the submit before the
// embedded-form handler sends it.
document.addEventListener(
  "submit",
  (event) => {
    let form = event.target.closest("[data-form-steps] form");
    if (!form) return;

    for (let step of formSteps(form)) {
      let invalid = firstInvalid(step);
      if (invalid) {
        event.preventDefault();
        event.stopImmediatePropagation();
        showFormStep(form, step);
        invalid.reportValidity();
        return;
      }
    }
  },
  true,
);

document.addEventListener("submit", async (event) => {
  let form = event.target.closest("form[data-embedded-form]");
  if (!form) return;

  event.preventDefault();
  clearEmbeddedFormErrors(form);

  let submitter = event.submitter;
  if (submitter) submitter.disabled = true;

  try {
    let response = await fetch(form.action, {
      method: form.method || "POST",
      body: new FormData(form),
      headers: { Accept: "application/json" },
      credentials: "same-origin",
    });
    let payload = await response.json();

    if (response.ok && payload.redirect_to) {
      showEmbeddedFormSuccess(form, payload);
      return;
    }

    showEmbeddedFormErrors(form, payload);
  } catch (_) {
    showEmbeddedFormErrors(form, {
      error: "We could not submit the form. Please check your connection and try again.",
    });
  } finally {
    if (submitter) submitter.disabled = false;
  }
});

let csrfToken = document
  .querySelector("meta[name='csrf-token']")
  .getAttribute("content");
let sessionId = document
  .querySelector("meta[name='session-id']")
  .getAttribute("content");
let industryStandardFormId = document
  .querySelector("meta[name='industry-standard-form-id']")
  .getAttribute("content");

document.addEventListener("trix-before-initialize", async () => {
  Trix.config.blockAttributes.heading2 = {
    tagName: "h2",
    terminal: true,
    breakOnReturn: true,
    group: false,
  };

  Trix.config.blockAttributes.heading3 = {
    tagName: "h3",
    terminal: true,
    breakOnReturn: true,
    group: false,
  };

  Trix.config.blockAttributes.heading4 = {
    tagName: "h4",
    terminal: true,
    breakOnReturn: true,
    group: false,
  };

  addEventListener("trix-initialize", (event) => {
    const { toolbarElement } = event.target;
    const h1Button = toolbarElement.querySelector(
      "[data-trix-attribute=heading1]",
    );
    const h2Button = toolbarElement.querySelector(
      "[data-trix-attribute=heading2]",
    );

    if (h2Button == undefined) {
      h1Button.insertAdjacentHTML(
        "afterend",
        `
        <button type="button" class="trix-button" data-trix-attribute="heading2" title="Heading2" tabindex="-1">
          <div class=" trix-button--icon trix-button--icon-heading-1 transform scale-125" />
        </button>
      `,
      );
    }

    const h3Button = toolbarElement.querySelector(
      "[data-trix-attribute=heading3]",
    );

    if (h3Button == undefined) {
      const h2Button = toolbarElement.querySelector(
        "[data-trix-attribute=heading2]",
      );
      h2Button.insertAdjacentHTML(
        "afterend",
        `
        <button type="button" class="trix-button" data-trix-attribute="heading3" title="Heading3" tabindex="-1">
          <div class=" trix-button--icon trix-button--icon-heading-1 transform scale-100" />
        </button>
      `,
      );
    }

    const h4Button = toolbarElement.querySelector(
      "[data-trix-attribute=heading4]",
    );

    if (h4Button == undefined) {
      const h3Button = toolbarElement.querySelector(
        "[data-trix-attribute=heading3]",
      );
      h3Button.insertAdjacentHTML(
        "afterend",
        `
        <button type="button" class="trix-button" data-trix-attribute="heading4" title="Heading 4" tabindex="-1">
          <div class=" trix-button--icon trix-button--icon-heading-1 transform scale-90" />
        </button>
      `,
      );
    }
  });
  // Change Trix.config if you need
});

function parseJSON(val) {
  try {
    let data = JSON.parse(val);
    return data;
  } catch (error) {
    return "";
  }
}

function initializePopup(el) {
  if (el.dataset.popupInitialized == "true") return;

  let popup = parseJSON(el.dataset.popup);
  if (!popup) return;

  el.dataset.popupInitialized = "true";

  let popupId = `popup-${popup.id}-shown`;

  if (sessionStorage.getItem(popupId) != "true") {
    el.classList.remove("opacity-0");

    if (popup.type == "modal") {
      el.classList.add("animate-expand");
    } else {
      el.classList.add("opacity-100");
    }

    el.classList.remove("hidden");

    let close = el.querySelector(`#close-popup-${popup.id}`);
    if (close) {
      close.addEventListener("click", () => {
        sessionStorage.setItem(popupId, "true");
        el.classList.add("hidden");
      });
    }
  } else {
    el.classList.add("hidden");
  }
}

document.addEventListener("DOMContentLoaded", (event) => {
  refreshParallax();

  document
    .querySelectorAll(".popup-overlay[data-popup]")
    .forEach(initializePopup);

  setupAdminCommandPalette();

  // Function that will be executed when the observed elements intersect with the viewport
  // Find all elements with the class 'your-class-name' and observe them
  //
  const elements = document.querySelectorAll(".underline-fancy");
  elements.forEach((element) => {
    let duration = element.dataset.duration ? element.dataset.duration : 100;
    let type = element.dataset.type ? element.dataset.type : "oneByOne";
    let opts = {
      type: type,
      duration: duration,
      animTimingFunction: Vivus.EASE_OUT,
    };

    if (element.dataset.svg) {
      opts.file = element.dataset.svg;
    }

    new Vivus(element.id, opts).play();
  });

  const expanders = document.querySelectorAll(".expander");
  expanders.forEach((element) => {
    const observer = new IntersectionObserver(
      (entries, observer) => {
        let duration = element.dataset.duration
          ? element.dataset.duration
          : 1000;
        let delay = element.dataset.delay ? element.dataset.delay : 100;

        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add(
              `animate-\[expand_${duration}ms_ease-out_${delay}ms\]`,
            );
            observer.unobserve(entry.target); // Optional: Stop observing the element after it becomes visible
          }
        });
      },
      {
        threshold: 0.1, // Trigger when at least 10% of the element is visible
      },
    );

    observer.observe(element);
  });

  baseOnIntersect(".shine-on", "shine-on-page");
  baseOnIntersect(".flowery", "animate-flower-wiggle");
  setupCarousel(".carousel");
  counterOnIntersect(".counter-odometer");
});

function counterOnIntersect(queryClass) {
  const expanders = document.querySelectorAll(queryClass);

  expanders.forEach((element) => {
    const observer = new IntersectionObserver(
      (entries, observer) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            let countTo = 580000;
            if (element.dataset.countto) {
              countTo = parseInt(element.dataset.countto);
            }

            let duration = 1;
            if (element.dataset.duration) {
              duration = element.dataset.duration;
            }
            const count = new CountUp(element, countTo, {
              plugin: new Odometer({
                duration: duration,
                lastDigitDelay: 0.3,
              }),
              useGrouping: false,
              duration: duration + 0.7,
              enableScrollSpy: true,
              formattingFn: function formy(amount) {
                let inputString = amount.toString();
                inputString = inputString.padStart(6, "0");
                let outputString = "";

                let n = 1;

                for (let i = 0; i < inputString.length; i += n) {
                  let slice = inputString.slice(i, i + n);

                  if (i != 0 && i % 3 == 0) {
                    outputString += `,${slice}`;
                  } else {
                    outputString += slice;
                  }
                }
                return outputString;
              },
            });
            count.start();
            observer.unobserve(entry.target); // Optional: Stop observing the element after it becomes visible
          }
        });
      },
      {
        threshold: 0.1, // Trigger when at least 10% of the element is visible
      },
    );

    observer.observe(element);
  });
}

function baseOnIntersect(queryClass, addClass) {
  const expanders = document.querySelectorAll(queryClass);

  expanders.forEach((element) => {
    const observer = new IntersectionObserver(
      (entries, observer) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add(addClass);
            observer.unobserve(entry.target); // Optional: Stop observing the element after it becomes visible
          }
        });
      },
      {
        threshold: 0.1, // Trigger when at least 10% of the element is visible
      },
    );

    observer.observe(element);
  });
}

function setupCarousel(queryClass) {
  const expanders = document.querySelectorAll(queryClass);

  expanders.forEach((element) => {
    let autoplay = element.dataset.autoplay;

    new Flickity(element, {
      // options, defaults listed

      accessibility: true,
      // enable keyboard navigation, pressing left & right keys

      adaptiveHeight: false,
      // set carousel height to the selected slide

      autoPlay: autoplay,
      // advances to the next cell
      // if true, default is 3 seconds
      // or set time between advances in milliseconds
      // i.e. `autoPlay: 1000` will advance every 1 second

      cellAlign: "center",
      // alignment of cells, 'center', 'left', or 'right'
      // or a decimal 0-1, 0 is beginning (left) of container, 1 is end (right)

      cellSelector: undefined,
      // specify selector for cell elements

      contain: false,
      // will contain cells to container
      // so no excess scroll at beginning or end
      // has no effect if wrapAround is enabled

      draggable: ">1",
      // enables dragging & flicking
      // if at least 2 cells

      dragThreshold: 3,
      // number of pixels a user must scroll horizontally to start dragging
      // increase to allow more room for vertical scroll for touch devices

      freeScroll: false,
      // enables content to be freely scrolled and flicked
      // without aligning cells

      friction: 0.2,
      // smaller number = easier to flick farther

      groupCells: false,
      // group cells together in slides

      initialIndex: 0,
      // zero-based index of the initial selected cell

      lazyLoad: true,
      // enable lazy-loading images
      // set img data-flickity-lazyload="src.jpg"
      // set to number to load images adjacent cells

      percentPosition: true,
      // sets positioning in percent values, rather than pixels
      // Enable if items have percent widths
      // Disable if items have pixel widths, like images

      prevNextButtons: true,
      // creates and enables buttons to click to previous & next cells

      pageDots: true,
      // create and enable page dots

      resize: true,
      // listens to window resize events to adjust size & positions

      rightToLeft: false,
      // enables right-to-left layout

      setGallerySize: true,
      // sets the height of gallery
      // disable if gallery already has height set with CSS

      watchCSS: false,
      // watches the content of :after of the element
      // activates if #element:after { content: 'flickity' }

      wrapAround: true,
      // at end of cells, wraps-around to first for infinite scrolling
    });
  });
}

import { SortableSlides } from "./hooks/sortable_slides.js";
import { SortableNavbar } from "./hooks/sortable_navbar.js";
import { DraggableStamp } from "./hooks/draggable_stamp.js";
import { RawHtmlSelector } from "./hooks/raw_html_selector.js";
import { InlineTextEditor } from "./hooks/inline_text_editor.js";
import { MotionPreview } from "./hooks/motion_preview.js";
import { AiInput } from "./hooks/ai_input.js";
import { InlineDescription, SortableQuestions } from "./hooks/fe2_inline.js";

let Hooks = {};

Hooks.Turnstile = TurnstileHook;
Hooks.SortableSlides = SortableSlides;
Hooks.SortableNavbar = SortableNavbar;
Hooks.DraggableStamp = DraggableStamp;
Hooks.RawHtmlSelector = RawHtmlSelector;
Hooks.InlineTextEditor = InlineTextEditor;
Hooks.MotionPreview = MotionPreview;
Hooks.AiInput = AiInput;
Hooks.InlineDescription = InlineDescription;
Hooks.SortableQuestions = SortableQuestions;

Hooks.ScrollToBottom = {
  mounted() {
    this.scrollToBottom();
  },
  // Measured before the patch: a long message just sent grows the list by more
  // than the threshold, so measuring after it read as "scrolled up".
  beforeUpdate() {
    const threshold = 100;
    this.wasNearBottom =
      this.el.scrollHeight - this.el.scrollTop - this.el.clientHeight <
      threshold;
  },
  updated() {
    // Only auto-scroll if user was near the bottom (not scrolling up to read history)
    if (this.wasNearBottom) this.scrollToBottom();
  },
  scrollToBottom() {
    this.el.scrollTop = this.el.scrollHeight;
  },
};

// "Working · 14s": seconds since the message last changed. A long model call
// (a whole build is one 30-60s call) otherwise looks stalled. `data-steps`
// changes with every new part, which is what resets it.
Hooks.QuietTimer = {
  mounted() {
    this.reset();
    this.timer = setInterval(() => {
      const s = Math.round((Date.now() - this.since) / 1000);
      const out = this.el.querySelector("[data-quiet]");
      if (out) out.textContent = s >= 5 ? ` · ${s}s` : "";
    }, 1000);
  },
  updated() {
    if (this.el.dataset.steps !== this.steps) this.reset();
  },
  reset() {
    this.since = Date.now();
    this.steps = this.el.dataset.steps;
  },
  destroyed() {
    clearInterval(this.timer);
  },
};

Hooks.CtrlEnterSubmit = {
  mounted() {
    this.el.addEventListener("keydown", (e) => {
      if (e.key === "Enter" && (e.ctrlKey || e.metaKey)) {
        e.preventDefault();
        this.el
          .closest("form")
          .dispatchEvent(new Event("submit", { bubbles: true }));
      }
    });
  },
};

Hooks.Popup = {
  mounted() {
    initializePopup(this.el);
  },
};

Hooks.SquarePayment = {
  async initCard(payments) {
    const card = await Square.initializeCard(payments, this.el);

    return card;
  },
  form() {
    return parseJSON(this.el.dataset.form);
  },
  destroyed() {
    clearInterval(this.validityTimer);
  },
  async mounted() {
    // Solving the Turnstile widget fires no DOM event, so Pay Now would stay
    // disabled if it is solved after the name/email fields (which do fire one).
    // ponytail: poll, swap for the widget's success callback if it gets flaky
    this.validityTimer = setInterval(() => Square.checkValidity(), 500);

    let payments;
    let card;
    let appId = Square.getMetaContent("box_app_id");
    let locationId = Square.getMetaContent("square_location");

    if (!window.Square) {
      console.log("Square.js failed to load properly");
    } else {
      let getterId = "formers";
      if (this.form()) {
        getterId = this.form().id;
      }

      let completeForm = document.getElementById(
        `form-inline-completion-${getterId}`,
      );
      if (completeForm) {
        completeForm.disabled = true;
      }

      try {
        payments = window.Square.payments(appId, locationId);
      } catch (error) {
        console.error("Initializing Payments failed");
        const statusContainer = document.getElementById(
          "payment-status-container",
        );
        statusContainer.className = "missing-credentials";
        statusContainer.style.visibility = "visible";
        return;
      }

      try {
        card = await this.initCard(payments);
      } catch (e) {
        console.error("Initializing Card failed", e);
        return;
      }

      let form = this.form();
      const cardButton = this.el.parentElement.querySelector("#payment-button");
      cardButton.addEventListener("click", async function (event) {
        const status = await Square.handlePaymentMethodSubmission(
          form,
          event,
          payments,
          card,
          cardButton,
        );

        return status;
      });
    }
  },
};

Hooks.SquareApplePay = {
  async initApple(payments) {
    const apple = await Square.initializeApplePay(payments, this.el);

    return apple;
  },
  form() {
    return parseJSON(this.el.dataset.form);
  },
  async mounted() {
    let payments;
    let card;
    let appId = Square.getMetaContent("box_app_id");
    let locationId = Square.getMetaContent("square_location");

    if (!window.Square) {
      console.log("Square.js failed to load properly");
    } else {
      let getterId = "formers";
      if (this.form()) {
        getterId = this.form().id;
      }

      let completeForm = document.getElementById(
        `form-inline-completion-${getterId}`,
      );

      if (completeForm) {
        completeForm.disabled = true;
      }

      try {
        payments = window.Square.payments(appId, locationId);
      } catch (error) {
        console.error("Initializing Payments failed", error);
        const statusContainer = document.getElementById(
          "payment-status-container",
        );
        statusContainer.className = "missing-credentials";
        statusContainer.style.visibility = "visible";
        return;
      }

      try {
        card = await this.initApple(payments);
      } catch (e) {
        console.error("Initializing Card failed", e);
        return;
      }

      let form = this.form();
      const cardButton = this.el.parentElement.querySelector("#payment-button");
      this.el.addEventListener("click", async function (event) {
        card = await Square.applePaymentRequest(payments);
        const status = await Square.handlePaymentMethodSubmission(
          form,
          event,
          payments,
          card,
          cardButton,
        );

        return status;
      });
    }
  },
};

Hooks.SquareGooglePay = {
  form() {
    return parseJSON(this.el.dataset.form);
  },
  async initGoogle(payments) {
    const google = await Square.initializeGoogle(payments, this.el);

    return google;
  },
  async mounted() {
    let payments;
    let card;
    let appId = Square.getMetaContent("box_app_id");
    let locationId = Square.getMetaContent("square_location");

    if (!window.Square) {
      console.log("Square.js failed to load properly");
    } else {
      try {
        payments = window.Square.payments(appId, locationId);
      } catch (error) {
        console.error("Initializing Payments failed", error);
        const statusContainer = document.getElementById(
          "payment-status-container",
        );
        statusContainer.className = "missing-credentials";
        statusContainer.style.visibility = "visible";
        return;
      }

      try {
        card = await this.initGoogle(payments);
      } catch (e) {
        console.error("Initializing Card failed");
        return;
      }

      let form = this.form();
      const cardButton = this.el.parentElement.querySelector("#payment-button");
      this.el.addEventListener("click", async function (event) {
        card = await Square.googlePaymentRequest(payments);
        const status = await Square.handlePaymentMethodSubmission(
          form,
          event,
          payments,
          card,
          cardButton,
        );

        return status;
      });
    }
  },
};

Hooks.RichTextEditor = {
  convert() {
    return parseJSON(this.el.dataset.convert);
  },
  content() {
    return parseJSON(this.el.dataset.content);
  },
  inline() {
    return parseJSON(this.el.dataset.inline);
  },
  mounted() {
    Editor.openNote(
      this.content().data,
      this.convert(),
      this.inline(),
      this.el,
      () => {
        console.log("callback");
      },
    );
  },
};

Hooks.TrixEditor = {
  updated() {
    var trixEditor = document.querySelector("trix-editor");

    if (null != trixEditor) {
      trixEditor.editor.loadHTML(this.el.value);
    }
  },
};

Hooks.Signature = {
  progess() {
    return parseJSON(this.el.dataset.count);
  },
  mounted() {
    Signature.signature();
  },
};

// From ChinWag
Hooks.InfiniteScroll = window.InfiniteScrollHook;

Hooks.Counter = {
  countTo() {
    return parseJSON(this.el.dataset.count);
  },
  duration() {
    if (this.el.dataset.duration) {
      return parseJSON(this.el.dataset.duration);
    } else {
      return 2.3;
    }
  },
  mounted() {
    const count = new CountUp(this.el, this.countTo(), {
      plugin: new Counter({
        duration: this.duration(),
        lastDigitDelay: 0.3,
      }),
      useGrouping: false,
      duration: this.duration() + 0.7,
      enableScrollSpy: true,
      formattingFn: function formy(amount) {
        let inputString = amount.toString();
        inputString = inputString.padStart(6, "0");
        let outputString = "";

        let n = 1;

        for (let i = 0; i < inputString.length; i += n) {
          let slice = inputString.slice(i, i + n);

          outputString += slice;
        }
        return outputString;
      },
    });
    count.start();
  },
};

Hooks.OdometerCount = {
  countTo() {
    return parseJSON(this.el.dataset.count);
  },
  duration() {
    if (this.el.dataset.duration) {
      return parseJSON(this.el.dataset.duration);
    } else {
      return 2.3;
    }
  },
  updated() {
    const count = new CountUp(this.el, this.countTo(), {
      plugin: new Odometer({
        duration: this.duration(),
        lastDigitDelay: 0.3,
      }),
      useGrouping: false,
      duration: this.duration() + 0.7,
      enableScrollSpy: true,
    });
    count.start();
  },
  mounted() {
    const count = new CountUp(this.el, this.countTo(), {
      plugin: new Odometer({
        duration: this.duration(),
        lastDigitDelay: 0.3,
      }),
      useGrouping: false,
      duration: this.duration() + 0.7,
      enableScrollSpy: true,
    });
    count.start();
  },
};

const jsConfetti = new JSConfetti();
Hooks.AnimateConfetti = {
  mounted() {
    this.el.addEventListener("click", (e) => {
      jsConfetti.addConfetti({
        emojis: ["🐶", "🐾", "🐱"],
        emojiSize: 60,
        confettiNumber: 30,
      });
    });
  },
};

Hooks.OnOtherVisibleAnimation = {
  other() {
    return this.el.dataset.other;
  },
  animation() {
    return this.el.dataset.animation;
  },
  removeAnimation() {
    return this.el.dataset.removeAnimation;
  },
  mounted() {
    let elemental = document.getElementById(this.other());

    if (elemental != undefined) {
      const observer = new IntersectionObserver(
        (entries, observer) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              this.el.classList.add(this.animation());
              this.el.classList.remove(this.removeAnimation());
            } else {
              this.el.classList.add(this.removeAnimation());
              this.el.classList.remove(this.animation());
            }
          });
        },
        {
          threshold: 0.1, // Trigger when at least 10% of the element is visible
        },
      );

      observer.observe(elemental);
    }
  },
};

Hooks.OnVisibleAnimation = {
  animation() {
    return this.el.dataset.animation;
  },
  removeAnimation() {
    return this.el.dataset.removeAnimation;
  },
  mounted() {
    const observer = new IntersectionObserver(
      (entries, observer) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add(this.animation());
            entry.target.classList.remove(this.removeAnimation());
            observer.unobserve(entry.target); // Optional: Stop observing the element after it becomes visible
          }
        });
      },
      {
        threshold: 0.1, // Trigger when at least 10% of the element is visible
      },
    );

    observer.observe(this.el);
  },
};

Hooks.CopyToClipboard = {
  copyText() {
    return parseJSON(this.el.dataset.copy_text);
  },
  mounted() {
    this.el.addEventListener("click", (e) => {
      let copyText = this.copyText().data;

      try {
        const type = "text/plain";
        const blob = new Blob([copyText], { type });
        const data = [new ClipboardItem({ [type]: blob })];

        navigator.clipboard.write(data).then(
          () => {},
          () => {
            console.log("Something went wrong");
          },
        );
      } catch (err) {
        console.log(err);
      } finally {
        this.el.textContent = "Copied ";

        setTimeout(function () {
          if (elemental) {
            elemental.textContent = "\n Copy \n";
          }
        }, 2000);
      }
    });
  },
};

Hooks.NoOp = {
  mounted() {},
};

Hooks.FocusOnMount = {
  mounted() {
    this.el.focus();
  },
};

Hooks.ScrollOnMount = {
  mounted() {
    this.el.scrollIntoView({
      behavior: "smooth",
      block: "start",
      inline: "nearest",
    });
  },
};

Hooks.FixedTagPopover = {
  mounted() {
    this.position();
    this.onReposition = () => this.position();
    window.addEventListener("resize", this.onReposition);
    window.addEventListener("scroll", this.onReposition, true);
  },
  updated() {
    this.position();
  },
  destroyed() {
    window.removeEventListener("resize", this.onReposition);
    window.removeEventListener("scroll", this.onReposition, true);
  },
  position() {
    let anchor = document.getElementById(this.el.dataset.anchorId);
    if (!anchor) return;

    let gap = 8;
    let margin = 12;
    let anchorRect = anchor.getBoundingClientRect();
    let popoverRect = this.el.getBoundingClientRect();

    let left = anchorRect.left;
    let top = anchorRect.bottom + gap;

    if (top + popoverRect.height > window.innerHeight - margin) {
      top = anchorRect.top - popoverRect.height - gap;
    }

    left = Math.min(left, window.innerWidth - popoverRect.width - margin);
    left = Math.max(margin, left);
    top = Math.min(top, window.innerHeight - popoverRect.height - margin);
    top = Math.max(margin, top);

    this.el.style.left = `${left}px`;
    this.el.style.top = `${top}px`;
  },
};

Hooks.AutoFocus = {
  mounted() {
    // Force focus at the end of input
    if (
      this.el.tagName == "INPUT" &&
      (this.el.type == "text" || this.el.type == "password")
    ) {
      let val = this.el.value;
      this.el.value = " ";
      this.el.value = val;
    }
    this.el.focus();
  },
};

Hooks.LocalTime = {
  mounted() {
    this.updated();
  },
  updated() {
    let dt = new Date(this.el.textContent.trim());
    let options = {
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
      timeZoneName: "short",
    };
    this.el.textContent = `${dt.toLocaleString("en-US", options)}`;
    this.el.classList.remove("invisible");
  },
};

Hooks.SharedSortable = {
  mounted() {
    console.log(this.el);
    let group = this.el.dataset.group;
    let sorter = new Sortable(this.el, {
      group: group ? { name: group, pull: true, put: true } : undefined,
      animation: 150,
      // delay: 100,
      dragClass: "drag-item",
      ghostClass: "drag-ghost",
      draggable: "> [data-id]",

      // forceFallback: true,
      onStart: function (evt) {
        document.activeElement.blur();
      },
      onEnd: (e) => {
        let params = {
          old: e.oldIndex,
          new: e.newIndex,
          to: e.to.dataset,
          ...e.item.dataset,
        };
        this.pushEventTo(
          this.el,
          this.el.dataset["drop"] || "reposition",
          params,
        );
      },
    });
  },
};

Hooks.Sortable = {
  group() {
    this.el.dataset.group;
  },
  mounted() {
    let sorter = new Sortable(this.el, {
      group: { name: this.group(), pull: true, put: true },
      animation: 150,
      // delay: 100,
      dragClass: "drag-item",
      ghostClass: "drag-ghost",

      // forceFallback: true,
      onStart: (e) => {
        document.activeElement.blur();
      },
      onEnd: (e) => {
        let params = {
          old: e.oldIndex,
          new: e.newIndex,
          to: e.to.dataset,
          ...e.item.dataset,
        };
        this.pushEventTo(
          this.el,
          this.el.dataset["drop"] || "reposition",
          params,
        );
      },
    });
  },
};

Hooks.SortableInputsFor = {
  mounted() {
    let group = this.el.dataset.group;
    let sorter = new Sortable(this.el, {
      group: { name: this.group(), pull: true, put: true },
      animation: 150,
      dragClass: "drag-item",
      ghostClass: "drag-ghost",
      handle: "[data-handle]",
      forceFallback: true,
      onStart: function (evt) {
        document.activeElement.blur();
      },
      onEnd: (e) => {
        this.el
          .closest("form")
          .querySelector("input")
          .dispatchEvent(new Event("input", { bubbles: true }));
      },
    });
  },
};

Hooks.WelcomeTourHook = WelcomeTour;
Hooks.TourHook = VetTour;
Hooks.ReviewTourHook = ReviewTour;
Hooks.AdminCampaignBuilderTourHook = AdminCampaignBuilderTourHook;
Hooks.ChartHook = setupChartHook();
Hooks.LineChartHook = setupLineChartHook();
Hooks.CampaignChartHook = setupCampaignChartHook();
Hooks.EmailChartHook = setupEmailChartHook();

let liveSocket = new LiveSocket("/live", Socket, {
  hooks: Hooks,
  params: {
    _csrf_token: csrfToken,
    session_id: sessionId,
    industry_standard_form_id: industryStandardFormId,
    locale: Intl.NumberFormat().resolvedOptions().locale,
    timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
    timezone_offset: -(new Date().getTimezoneOffset() / 60),
  },
});

// Show progress bar on live navigation and form submits. Only displays if still
// loading after 120 msec
//
// <button data-copy="..." phx-click={JS.dispatch("phx:copy")}>; flags data-copied briefly for feedback.
window.addEventListener("phx:copy", (e) => {
  const el = e.target;
  navigator.clipboard.writeText(el.dataset.copy).then(() => {
    el.dataset.copied = "";
    setTimeout(() => delete el.dataset.copied, 1500);
  });
});

window.addEventListener("phx:page-loading-start", (info) => NProgress.start());
window.addEventListener("phx:page-loading-stop", (info) => NProgress.done());
//
//
// topbar.config({barColors: {0: "#29d"}, shadowColor: "rgba(0, 0, 0, .3)"})
//
// let topBarScheduled = undefined;
// window.addEventListener("phx:page-loading-start", () => {
//   if(!topBarScheduled) {
//     topBarScheduled = setTimeout(() => topbar.show(), 1);
//   };
// });
// window.addEventListener("phx:page-loading-stop", () => {
//   clearTimeout(topBarScheduled);
//   topBarScheduled = undefined;
//   topbar.hide();
// });

// document.documentElement.style.setProperty('--vh', `${vh}px`)
//
//
//
function setViewHeight() {
  let vh = window.innerHeight;
  document.documentElement.style.setProperty("--vh", `${vh}px`);
}

let initialViewHeight = window.innerHeight;

document.documentElement.style.setProperty("--vh", `${initialViewHeight}px`);
window.addEventListener("load", function () {
  setViewHeight();
});
window.addEventListener("resize", function () {
  setViewHeight();
});
window.addEventListener("js:set", (e) => {
  e.target[e.detail.key] = e.detail.value;
});

window.addEventListener("js:toggle-class-on-value", (e) => {
  const el = document.querySelector(`#${e.detail.id}`);

  if (el) {
    if (e.target.value == e.detail.expected_value) {
      el.classList.remove(`${e.detail.class}`);
    } else {
      el.classList.add(`${e.detail.class}`);
    }
  }
});

window.addEventListener("js:pulse-border", (e) => {
  const el = e.target;
  el.classList.add("animate-border-pulse");
  setTimeout(() => el.classList.remove("animate-border-pulse"), 2000);
});

window.addEventListener("js:checkValidity", (_e) => {
  Square.checkValidity();
});

// `[data-aos]` elements start at opacity 0 and are only revealed by AOS, so any
// context where AOS does not run leaves the content invisible. Disabling AOS
// under reduced motion both honours the preference and makes headless preview
// captures (which force it) show the settled page instead of a blank one.
AOS.init({
  disable: () => window.matchMedia("(prefers-reduced-motion: reduce)").matches,
});

// The page editor's motion toggle re-arms AOS after unpinning the preview.
window.AOS = AOS;

// connect if there are any LiveViews on the page
liveSocket.connect();

// expose liveSocket on window for web console debug logs and latency simulation:
// >> liveSocket.enableDebug()
// >> liveSocket.enableLatencySim(1000)
window.liveSocket = liveSocket;
